// extracted by mini-css-extract-plugin
var _1 = "styles-module__disclaimer___ZhQyu";
var _2 = "styles-module__terms___ryTZX";
var _3 = "styles-module__welcomeContent___mADqX";
export { _1 as "disclaimer", _2 as "terms", _3 as "welcomeContent" }
